import { useState } from "react";
import { FeedbackModal } from "./FeedbackModal";

/**
 * Floating "Feedback" pill rendered on every authenticated page.
 * Opens the FeedbackModal — the same form that the MCP submit_feedback tool
 * targets, so users and agents share an inbox.
 */
export function FeedbackButton() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button
        type="button"
        onClick={() => setOpen(true)}
        className="fixed bottom-6 right-6 z-40 rounded-full bg-slate-900 px-4 py-2 text-sm font-medium text-white shadow-lg hover:bg-slate-700"
      >
        Feedback
      </button>
      <FeedbackModal open={open} onClose={() => setOpen(false)} />
    </>
  );
}
